import { RootState } from "@src/reducers/store";
import { updateConnectedGatewaysListData } from "@src/reducers/your-reducer";
import { useDispatch, useSelector } from "react-redux";

export const useGatewaysListHeaderHook = () => {
  const dispatch = useDispatch();

  const connectedGatewaysListData = useSelector(
    (state: RootState) => state.yourSlice.connectedGatewaysListData,
  );

  const anySourcesVisible = connectedGatewaysListData.some(
    (gateway) => gateway.sources_visible === true,
  );

  const allCollapsed = connectedGatewaysListData.every(
    (gateway) => gateway.sources_visible === false,
  );

  const expandAllClickHandler = () => {
    const newConnectedGatewaysListData = connectedGatewaysListData.map(
      (gateway) => ({ ...gateway, sources_visible: true }),
    );

    dispatch(updateConnectedGatewaysListData(newConnectedGatewaysListData));
  };

  const closeAllClickHandler = () => {
    const newConnectedGatewaysListData = connectedGatewaysListData.map(
      (gateway) => ({ ...gateway, sources_visible: false }),
    );

    dispatch(updateConnectedGatewaysListData(newConnectedGatewaysListData));
  };

  return {
    anySourcesVisible,
    allCollapsed,
    expandAllClickHandler,
    closeAllClickHandler,
  };
};
